<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmGroup"
      :title="'CADASTRO DE ASSOCIADO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave"
    >
      <div class="col-md-12 form-group row pb-3">
        <h5 class="col-md-12 text-third">Informações de Pessoa</h5>
      </div>
      <div class="col-md-12 form-group row pb-3">
        <div class="col-md-3">
          <NxInputDocument
            @update:value="handleInputUpdate('pessoa.document', $event, false)"
            @tipoPessoa="setTipoPessoaField"
            @dadosPessoa="setPessoaFields"
            v-model="form.pessoa.document"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            :isDisabled="form.id ? true : false"
          />
        </div>
        <div class="col-md-2">
          <NxSelectTipoPessoa
            @update:value="handleSelectUpdate('pessoa.tipoPessoa', $event)"
            v-model="form.pessoa.tipoPessoa"
          />
        </div>
        <div class="col-md-5">
          <NxInputNome
            @update:value="
              handleInputUpdate('pessoa.nomeCompleto', $event, false)
            "
            v-model="form.pessoa.nomeCompleto"
          />
        </div>
        <div class="col-md-2">
          <NxInputDate
            variable="de Nascimento"
            :maxToday="true"
            @update:value="
              handleInputUpdate('pessoa.dataNascimento', $event, false)
            "
            v-model="form.pessoa.dataNascimento"
          />
        </div>
      </div>

      <div class="col-md-12 form-group row pb-3">
        <div class="col-md-4">
          <NxSelectEscolaridade
            @update:value="handleSelectUpdate('pessoa.escolaridade', $event)"
            v-model="form.pessoa.escolaridade"
          />
        </div>
        <div class="col-md-3">
          <NxSelectEstadoCivil
            @update:value="handleSelectUpdate('pessoa.estadoCivil', $event)"
            v-model="form.pessoa.estadoCivil"
          />
        </div>
        <div class="col-md-3">
          <NxInputNaturalidade
            @update:value="handleInputUpdate('pessoa.naturalidade', $event)"
            v-model="form.pessoa.naturalidade"
          />
        </div>
        <div class="col-md-2">
          <NxSelectSexo
            @update:value="handleSelectUpdate('pessoa.sexo', $event)"
            v-model="form.pessoa.sexo"
          />
        </div>
      </div>

      <div class="col-md-12 form-group row pb-3">
        <div class="col-md-3">
          <NxInputNumeroDocumentoIdentidade
            @update:value="
              handleInputUpdate('pessoa.numeroDocumentoIdentidade', $event)
            "
            v-model="form.pessoa.numeroDocumentoIdentidade"
          />
        </div>
        <div class="col-md-7">
          <NxInputEmail
            @update:value="handleInputUpdate('pessoa.email', $event, false)"
            v-model="form.pessoa.email"
          />
        </div>
        <div class="col-md-2">
          <NxInputSiglaUFOrgaoExpeditor
            @update:value="
              handleInputUpdate('pessoa.siglaUFOrgaoExpeditor', $event)
            "
            v-model="form.pessoa.siglaUFOrgaoExpeditor"
          />
        </div>
      </div>

      <div class="col-md-12">
        <div
          class="border p-3 mb-3 col-md-6"
          v-for="(telefone, index) in form.pessoa.telefone"
          :key="index + 'telefone'"
        >
          <div class="form-group row">
            <div class="col-md-6">
              <NxSelectTipoContato
                @update:value="
                  handleSelectUpdate(
                    `pessoa.telefone[${index}].tipoContato`,
                    $event
                  )
                "
                v-model="telefone.tipoContato"
              />
            </div>

            <div class="col-md-5">
              <NxInputTelefone
                @update:value="
                  handleInputUpdate(
                    `pessoa.telefone[${index}].telefone`,
                    $event
                  )
                "
                v-model="telefone.telefone"
              />
            </div>

            <div
              class="col-md-1 mt-4"
              style="align-self: center; margin: 0 auto; text-align: center"
            >
              <i
                v-on:click="onDeleteTelefone(index)"
                class="fa fa-trash text-danger icone-grid"
                v-b-tooltip.hover
                :title="'Clique para remover o telefone'"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2 pb-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="onCreateNewTelefoneForm()"
          v-b-tooltip.hover
        >
          <i class="fas fa-plus"></i>
          <span class="d-md-down-none"> Adicionar Telefone</span>
        </button>
      </div>

      <div class="col-md-12">
        <div
          class="border p-3 mb-3 col-md-12"
          style="border-right: 1px solid gray"
          v-for="(endereco, index) in form.pessoa.endereco"
          :key="index + 'endereco'"
        >
          <div class="row">
            <div class="col-md-11">
              <div class="form-group row">
                <div class="col-md-3">
                  <NxInputCep
                    @update:value="
                      handleInputUpdate(`pessoa.endereco[${index}].cep`, $event)
                    "
                    @endereco="loadEnderecoByCep($event, index)"
                    v-mask="['#####-###']"
                    v-model="form.pessoa.endereco[index].cep"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-2">
                  <NxSelectTipoLogradouro
                    @update:value="
                      handleSelectUpdate(
                        `pessoa.endereco[${index}].tipoLogradouro`,
                        $event
                      )
                    "
                    v-model="form.pessoa.endereco[index].tipoLogradouro"
                  />
                </div>
                <div class="col-md-8">
                  <NxInputEndereco
                    @update:value="
                      handleInputUpdate(
                        `pessoa.endereco[${index}].logradouro`,
                        $event
                      )
                    "
                    v-model="form.pessoa.endereco[index].logradouro"
                  />
                </div>
                <div class="col-md-2">
                  <NxInputEnderecoNumero
                    @update:value="
                      handleInputUpdate(
                        `pessoa.endereco[${index}].numero`,
                        $event
                      )
                    "
                    v-model="form.pessoa.endereco[index].numero"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-3">
                  <NxInputEnderecoComplemento
                    @update:value="
                      handleInputUpdate(
                        `pessoa.endereco[${index}].complemento`,
                        $event
                      )
                    "
                    v-model="form.pessoa.endereco[index].complemento"
                  />
                </div>
                <div class="col-md-3">
                  <NxSelectUF
                    @update:value="
                      handleSelectUpdate(`pessoa.endereco[${index}].uf`, $event)
                    "
                    v-model="form.pessoa.endereco[index].uf"
                  />
                </div>
                <div class="col-md-3">
                  <NxInputMunicipio
                    @update:value="
                      handleInputUpdate(
                        `pessoa.endereco[${index}].municipio`,
                        $event
                      )
                    "
                    v-model="form.pessoa.endereco[index].municipio"
                  />
                </div>
                <div class="col-md-3">
                  <NxInputBairro
                    @update:value="
                      handleInputUpdate(
                        `pessoa.endereco[${index}].bairro`,
                        $event
                      )
                    "
                    v-model="form.pessoa.endereco[index].bairro"
                  />
                </div>
              </div>
            </div>

            <div
              class="col-md-1"
              style="align-self: center; text-align: center"
            >
              <i
                v-on:click="onDeleteEndereco(index)"
                class="fa fa-trash text-danger icone-grid"
                v-b-tooltip.hover
                :title="'Clique para remover o telefone'"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2 pb-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="onCreateNewEndereco()"
          v-b-tooltip.hover
        >
          <i class="fas fa-plus"></i>
          <span class="d-md-down-none"> Adicionar Endereço</span>
        </button>
      </div>

      <hr />

      <div class="col-md-12 form-group row pb-3">
        <h5 class="col-md-12 text-third">Informações de Associado</h5>
      </div>

      <div class="col-md-12 form-group row pb-3">
        <div class="col-md-3">
          <NxInputNumId
            @update:value="handleInputUpdate('numId', $event, false)"
            v-model="form.numId"
          />
        </div>
        <div class="col-md-3">
          <NxSelectFuncionario
            :variable="employeeTypes.GERENTE"
            :multiple="false"
            @update:value="handleSelectUpdate('gerenteId', $event)"
            v-model="form.gerenteId"
          />
        </div>
        <div class="col-md-3">
          <NxSelectPA
            @update:value="handleSelectUpdate('paId', $event)"
            :multiple="false"
            v-model="form.paId"
          />
        </div>
        <div class="col-md-3">
          <NxSelectCluster
            @update:value="handleSelectUpdate('clusterizacaoId', $event)"
            :multiple="false"
            v-model="form.clusterizacaoId"
          />
        </div>
      </div>

      <div class="col-md-12 form-group row pb-3">
        <div class="col-md-3">
          <NxInputDate
            variable="de Inicio do Relacionamento"
            :maxToday="true"
            @update:value="
              handleInputUpdate('inicioRelacionamento', $event, false)
            "
            v-model="form.inicioRelacionamento"
          />
        </div>
        <div class="col-md-3">
          <NxInputDate
            variable="de Ultima Renovação"
            :maxToday="true"
            @update:value="handleInputUpdate('ultimaRenovacao', $event, false)"
            v-model="form.ultimaRenovacao"
          />
        </div>
      </div>

      <div class="col-md-12 form-group row">
        <div class="col-md-3">
          <label
            style="
              font-size: medium;
              letter-spacing: 0.3px;
              color: #2e6e60;
              cursor: pointer;
            "
            @click.prevent="showRendaInformations = !showRendaInformations"
          >
            <i
              v-if="showRendaInformations"
              class="fas fa-caret-down"
            ></i>
            <i
              v-else
              class="fas fa-caret-right"
            ></i>
            Dados de Renda
          </label>
          <i
            v-if="hasRendaInformations"
            class="fas fa-check pl-2"
            style="color: #2e6e60"
          ></i>
        </div>
      </div>
      <div v-if="showRendaInformations">
        <div class="col-md-12 form-groups row">
          <div class="col-md-2">
            <NxInputMoney
              :value="form.rendaBrutaMensal || 0"
              labelText="Renda Bruta Mensal:"
              @update:value="
                handleInputUpdate('rendaBrutaMensal', $event, false)
              "
            />
          </div>
          <div class="col-md-5">
            <NxInputTipoRenda
              @update:value="handleInputUpdate('tipoRenda', $event, false)"
              v-model="form.tipoRenda"
            />
          </div>
          <div class="col-md-5">
            <NxInputVinculoEmpregaticio
              @update:value="
                handleInputUpdate('vinculoEmpregaticio', $event, false)
              "
              v-model="form.vinculoEmpregaticio"
            />
          </div>
        </div>

        <div class="col-md-12 form-groups row">
          <div class="col-md-12">
            <NxInputDescricaoProfissao
              @update:value="
                handleInputUpdate('descricaoProfissao', $event, false)
              "
              v-model="form.descricaoProfissao"
            />
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>

<script>
import {
  NxInputBairro,
  NxInputCep,
  NxInputDate,
  NxInputDescricaoProfissao,
  NxInputDocument,
  NxInputEmail,
  NxInputEndereco,
  NxInputEnderecoComplemento,
  NxInputEnderecoNumero,
  NxInputMoney,
  NxInputMunicipio,
  NxInputNaturalidade,
  NxInputNome,
  NxInputNumeroDocumentoIdentidade,
  NxInputNumId,
  NxInputSiglaUFOrgaoExpeditor,
  NxInputTelefone,
  NxInputText,
  NxInputTipoRenda,
  NxInputVinculoEmpregaticio
} from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectCluster,
  NxSelectEscolaridade,
  NxSelectEstadoCivil,
  NxSelectFuncionario,
  NxSelectPA,
  NxSelectSexo,
  NxSelectTipoContato,
  NxSelectTipoLogradouro,
  NxSelectTipoPessoa,
  NxSelectUF
} from '@/components/nexum/components/custom-selects/index.js'
import { advancedOnException } from '@/components/tools/Utils'
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'AssociateRegistrationAdd',
  components: {
    NxInputDocument,
    NxSelectTipoPessoa,
    NxInputNome,
    NxInputDate,
    NxSelectEscolaridade,
    NxSelectEstadoCivil,
    NxInputNaturalidade,
    NxSelectSexo,
    NxInputNumeroDocumentoIdentidade,
    NxInputSiglaUFOrgaoExpeditor,
    NxInputEmail,
    NxInputText,
    NxInputMoney,
    NxInputDescricaoProfissao,
    NxInputVinculoEmpregaticio,
    NxInputTipoRenda,
    NxSelectFuncionario,
    NxSelectPA,
    NxSelectCluster,
    NxInputNumId,
    NxInputTelefone,
    NxSelectTipoContato,
    NxInputCep,
    NxInputEndereco,
    NxInputEnderecoNumero,
    NxSelectUF,
    NxInputMunicipio,
    NxSelectTipoLogradouro,
    NxInputEnderecoComplemento,
    NxInputBairro
  },
  mixins: [ActionsForm],
  data () {
    return {
      showRendaInformations: false,
      hasRendaInformations: false,
      form: {
        numId: null,
        gerenteId: null,
        paId: null,
        clusterizacaoId: null,
        inicioRelacionamento: null,
        ultimaRenovacao: null,
        rendaBrutaMensal: null,
        tipoRenda: null,
        vinculoEmpregaticio: null,
        descricaoProfissao: null,
        pessoa: {
          document: null,
          tipoPessoa: null,
          nomeCompleto: null,
          dataNascimento: null,
          escolaridade: null,
          estadoCivil: null,
          naturalidade: null,
          sexo: null,
          numeroDocumentoIdentidade: null,
          siglaUFOrgaoExpeditor: null,
          email: null,
          telefone: [],
          endereco: []
        }
      },
      employeeTypes: employeeTypes
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onClear () {
      this.form.id = null
      this.clearForm()
    },
    onLoad () {},
    onEdit (obj) {
      this.form.id = obj.id
      this.form.pessoa.document = obj.pessoa.document
      this.loadPersonFields(obj.pessoa)
      this.loadAssociadoFields(obj)
    },
    onSave () {
      if (this.form.id != null) this.onUpdate()
      else this.onCreate()
    },
    async onCreate () {
      try {
        loading.push()

        const { status } = await AssociateRepository.Create(this.form)

        if (status === 201) {
          toast.success(this.$lang.Common.Alerts.Success)
          this.onBack()
        }
      } catch (err) {
        advancedOnException(err, this.$lang)
      } finally {
        loading.pop()
      }
    },
    async onUpdate () {
      try {
        loading.push()

        const { status } = await AssociateRepository.UpdateFromConfig(
          this.form.id,
          this.form
        )

        if (status === 200) {
          toast.success(this.$lang.Common.Alerts.Success)
          this.onBack()
        }
      } catch (err) {
        advancedOnException(err, this.$lang)
      } finally {
        loading.pop()
      }
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        const value = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
        this.setField(fieldName, value)
      } else {
        this.clearField(fieldName)
      }
    },
    clearField (fieldName) {
      this.setField(fieldName, null)
    },
    clearForm () {
      this.$root.$emit('clearForm')
    },
    handleSelectUpdate (fieldName, selectedValue) {
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.setField(fieldName, selectedValue)
      } else if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
      } else if (selectedValue) {
        const value = Array.isArray(selectedValue)
          ? selectedValue.map((v) => v.value)
          : selectedValue.value
        this.setField(fieldName, value)
      } else {
        this.clearField(fieldName)
      }
    },
    setField (fieldName, value) {
      const keys = fieldName.split('.')
      const lastKey = keys.pop()
      const target = keys.reduce((obj, key) => {
        if (!(key in obj)) obj[key] = {}
        return obj[key]
      }, this.form)
      target[lastKey] = value
    },
    setTipoPessoaField (val) {
      if (val) this.form.pessoa.tipoPessoa = val
    },
    setPessoaFields (val) {
      if (this.form.id) return

      if (val) this.loadPersonFields(val)
      else this.clearPersonFields()
    },
    onCreateNewTelefoneForm () {
      this.form.pessoa.telefone.push({
        telefone: null,
        tipoContato: null
      })
    },
    onDeleteTelefone (index) {
      this.form.pessoa.telefone.splice(index, 1)
    },
    onCreateNewEndereco () {
      this.form.pessoa.endereco.push({
        tipoLogradouro: null,
        logradouro: null,
        complemento: null,
        numero: null,
        bairro: null,
        municipio: null,
        uf: null,
        cep: null
      })
    },
    onDeleteEndereco (index) {
      this.form.pessoa.endereco.splice(index, 1)
    },
    loadEnderecoByCep (data, index) {
      try {
        loading.push()
        this.form.pessoa.endereco[index].logradouro = data.logradouro
        this.form.pessoa.endereco[index].bairro = data.bairro
        this.form.pessoa.endereco[index].municipio = data.localidade
        this.form.pessoa.endereco[index].uf = data.uf
      } catch (err) {
        toast.warning(
          'Não foi possivel carregar informações de endereco pelo CEP'
        )
      } finally {
        loading.close()
      }
    },
    loadPersonFields (pessoaObj) {
      if (!pessoaObj) return

      this.form.pessoa.tipoPessoa = pessoaObj.tipoPessoa
      this.form.pessoa.nomeCompleto = pessoaObj.nome
      this.form.pessoa.dataNascimento = pessoaObj.dataNascimento
        ? pessoaObj.dataNascimento.split('T')[0]
        : null
      this.form.pessoa.escolaridade = pessoaObj.escolaridade
      this.form.pessoa.estadoCivil = pessoaObj.estadoCivil
      this.form.pessoa.naturalidade = pessoaObj.naturalidade
      this.form.pessoa.sexo = ['F', 'M'].includes(pessoaObj.sexo) ? pessoaObj.sexo : null
      this.form.pessoa.numeroDocumentoIdentidade =
        pessoaObj.numeroDocumentoIdentidade
      this.form.pessoa.siglaUFOrgaoExpeditor = pessoaObj.siglaUFOrgaoExpeditor
      this.form.pessoa.email = pessoaObj.email

      this.form.pessoa.telefone = pessoaObj.telefone ? pessoaObj.telefone : []
      this.form.pessoa.endereco = pessoaObj.endereco ? pessoaObj.endereco : []
    },
    loadAssociadoFields (assocaidoObj) {
      this.form.numId = assocaidoObj.numId
      this.form.gerenteId = assocaidoObj.gerente
        ? assocaidoObj.gerente.id
        : null
      this.form.paId = assocaidoObj.pa ? assocaidoObj.pa.id : null
      this.form.clusterizacaoId = assocaidoObj.clusterizacaoDTO
        ? assocaidoObj.clusterizacaoDTO.id
        : null
      this.form.inicioRelacionamento = assocaidoObj.inicioRelacionamento
        ? assocaidoObj.inicioRelacionamento.split('T')[0]
        : null
      this.form.ultimaRenovacao = assocaidoObj.ultimaRenovacao
        ? assocaidoObj.ultimaRenovacao.split('T')[0]
        : null
      this.form.rendaBrutaMensal = assocaidoObj.rendaBrutaMensal
      this.form.tipoRenda = assocaidoObj.tipoRenda
      this.form.vinculoEmpregaticio = assocaidoObj.vinculoEmpregaticio
      this.form.descricaoProfissao = assocaidoObj.descricaoProfissao
    },
    clearPersonFields () {
      this.form.pessoa.tipoPessoa = null
      this.form.pessoa.nomeCompleto = null
      this.form.pessoa.dataNascimento = null
      this.form.pessoa.escolaridade = null
      this.form.pessoa.estadoCivil = null
      this.form.pessoa.naturalidade = null
      this.form.pessoa.sexo = null
      this.form.pessoa.numeroDocumentoIdentidade = null
      this.form.pessoa.siglaUFOrgaoExpeditor = null
      this.form.pessoa.email = null

      this.form.pessoa.telefone = []
      this.form.pessoa.endereco = []
    },
    clearAssociadoFields () {
      this.form.numId = null
      this.form.gerenteId = null
      this.form.paId = null
      this.form.clusterizacaoId = null
      this.form.inicioRelacionamento = null
      this.form.ultimaRenovacao = null
      this.form.rendaBrutaMensal = null
      this.form.tipoRenda = null
      this.form.vinculoEmpregaticio = null
      this.form.descricaoProfissao = null
    }
  }
}
</script>

<style scoped>
v-select {
  border-radius: 0% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/Associate/components/add/AssociateRegistrationAdd.vue